import { ArtestCampaignGallery } from "./features/artest-gallery/artest-campaign-gallery";
import { ArtestGallery } from "./features/artest-gallery/artest-gallery";
import { API_GET } from "./utils/api";
let _globalThis = window;
_globalThis.ArtestGallery = _globalThis.ArtestGallery || ArtestGallery;
_globalThis.ArtestCampaignGallery = _globalThis.ArtestCampaignGallery || ArtestCampaignGallery;
_globalThis.Artest = _globalThis.Artest || {};
_globalThis.Artest.API_GET = API_GET;
